import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Container, Typography, Grid, Tooltip, useMediaQuery, Button, Box } from "@mui/material";
import { theme } from "../../styles/theme";
import GraphScoreMeter from "../../components/GraphScoreMeter/GraphScoreMeter";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/Footer";
import role from "../../redux/actions/role";
import chart from "../../redux/actions/chart";
import moment from "moment";
import SimpleSnackbar from "../../components/controls/ToastMessage";
import DownloadIcon from "@mui/icons-material/Download";
import QuizSection from "../../components/quizsections";
import { codingLanguageDisplay } from "../../services/globalService";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import VideoStream from "./VideoStream";
// import SessionTracking from "./SessionTracking";
// import ImageCarousel from "../../components/ImageCarousel";
import VideoAndSessionTracking from "./videoAndSessionTracking";
import { RadarChart } from "../../components/chart/RadarChart";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

// styles for this component
const useStyles = makeStyles({
  container: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingBottom: "3rem",
  },
  viewText: {
    // FK cleanup july 2023
    fontFamily: `${theme.font.fontFamily} !important`,
    fontStyle: `${theme.font.fontStyle} !important`,
    fontSize: "16px !important",
  },
  roletype: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletype1: {
    // FK cleanup july 2023
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletext: {
    // FK cleanup july 2023
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    fontSize: "24px !important",
    lineHeight: "28px !important",
    letterSpacing: "-0.02em !important",
    color: "#2F2F2F",
    textAlign: "center",
    flex: "none",
    order: 0,
    flexGrow: 0,
    paddingTop: "10px",
  },
  spaceflex: {
    // FK cleanup july 2023
    display: "flex",
    justifyContent: "space-between",
  },
  down_arrow: {
    // FK cleanup july 2023
    padding: "8px",
    marginTop: "10px",
  },
  btn: {
    // FK cleanup july 2023
    width: "240px !important",
    textTransform: "none !important",
    background: "#1789FC !important",
  },
  cancel_btn: {
    // FK cleanup july 2023
    width: "112px !important",
    textTransform: "none !important",
    background: "transparent !important",
    color: "#787878 !important",
    boxShadow: "none !important",
  },
  previous_btn: {
    // FK cleanup july 2023
    width: "240px !important",
    textTransform: "none !important",
    background: "transparent !important",
    color: "#1789FC !important",
    boxShadow: "none !important",
    border: "1px solid #C4C4C4 !important",
    marginRight: "10px !important",
  },
  field: {
    // FK cleanup july 2023
    minHeight: 30,
    marginTop: 8,
    backgroundColor: theme.palette.btnPrimary.light,
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: "0px",
    },
  },
  // score number style
  scoreLeftArea: {
    // FK cleanup july 2023
    // padding: 8,
    width: "100%",
    "@media (min-width:1450px)": {
      width: "442px",
    },
  },
  scoreText: {
    // FK cleanup july 2023
    padding: "20px",
  },
  scoreMeter: {
    top: "-90px !important",
    position: "relative !important",
  },
  threeLine4: {
    color: "#787878",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center !important",
    fontWeight: "400 !important",
    marginTop: "10px",
  },
  textareasty: {
    // FK cleanup july 2023
    width: "100%",
    background: "#EBEFF8",
    borderRadius: "4px",
    border: "none",
    outline: "none",
    padding: "10px",
    marginTop: "10px",
    "&::placeholder": {
      fontFamily: "Roboto",
      color: "#787878",
      fontSize: "16px",
    },
  },
  textdot: {
    color: "#787878",
    fontSize: "48px !important",
    lineHeight: "20px",
    textAlign: "center !important",
    fontWeight: "600 !important",
    marginTop: "10px",
  },
  grid_root: {
    marginTop: "0px !important",
    marginLeft: "0px !important",
  },
  linksty: {
    color: "#1789FC",
    fontWeight: "500 !important",
    cursor: "pointer",
    padding: "0px",
    fontSize: "16px !important",
  },
  linksty1: {
    color: "#787878",
    fontWeight: "500 !important",
    // cursor: 'pointer',
    padding: "0px",
    fontSize: "16px !important",
  },
  datepickersty: {
    // FK cleanup july 2023
    // "& .MuiInputBase-root":{
    //     width:'533px',
    //     backgroundColor:`${theme.palette.btnPrimary.light}`,
    //     marginTop:'10px'
    // },
    width: "0px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "0px !important",
    },
    "& .MuiInputAdornment-root ": {
      position: "absolute",
      top: "22px",
    },
  },
  grayText: {
    // FK cleanup july 2023
    color: "#787878",
  },
  link: {
    // FK cleanup july 2023

    fontFamily: "Roboto",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0em",
    textalign: "left",
    textDecoration: "none !important",
    color: "#1789FC!important",
    "& .css-1ps4owl-MuiTypography-root-MuiLink-root": {
      textDecoration: "none !important",
      color: "#1789FC !important",
    },
  },
  linkCursor: {
    // FK cleanup july 2023
    cursor: "pointer",
  },
  roundedCircle: {
    // FK cleanup july 2023
    height: "12px",
    width: "12px",
    margin: "2px 3px 2px 14px",
    border: "1px solid #C4C4C4",
    borderRadius: "50%",
  },
  redLabel: {
    // FK cleanup july 2023
    color: "#DD2E2E",
  },
  // graph meter container
  graphScoreMeterContainer: {
    position: "relative",
    height: "368px",
    border: "24px solid #FFFBF6",
    borderRadius: "4px",
  },
  // graph meter canvas
  graphScoreMeterCanvas: {
    position: "relative",
    height: "320px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  // upto 900px mobile view container
  mobileGraphScoreMeterContainer: {
    // minWidth: "500px",
    position: "relative",
    border: "24px solid #FFFBF6",
    borderRadius: "4px",
  },
  // upto 900px mobile view canvas
  mobileGraphScoreMeterCanvas: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "350px",
  },
  leftSideContaint: {
    color: "#2F2F2F !important",
    fontStyle: "normal !important",
    fontWeight: "500  !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
  },
  linkStyles: {
    textDecoration: "none !important",
    cursor: "pointer !important",
    color: "black",
    textOverflow: "ellipsis !important",
    overflow: "hidden",
    display: "block",
  },
  muiBtn: {
    textTransform: "none !important",
    color: "gray !important",
    fontSize: "20px !important",
    fontWeight: "400 !important",
    borderRadius: "4px !important",
    // '&:hover': {
    //   backgroundColor: '#1789FC !important',
    // },
  },
  muiBtnActive: {
    textTransform: "none !important",
    color: "primary !important",
    fontSize: "20px !important",
    fontWeight: "500 !important",
    borderRadius: "4px !important",
  },
  notAvailable: {
    border: "1px solid #C4C4C4",
    borderRadius: "4px",
    padding: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: "20vh",
  },
});

export default function InviteCandidateView() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id, accessCode } = useParams();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const roleState = useSelector((state) => state.role);
  const chartState = useSelector((state) => state.chart);
  const isAuthLoading = useSelector((state) => state.auth.isauthLoading);
  const isInvitePageLoading = useSelector((state) => state.role.isCandidateRoleLoading);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [snacktext, setsnacktext] = useState("");
  const [open, setOpen] = useState(false);
  const [inviteLastUpdatedDate, setInviteLastUpdatedDate] = useState("");
  const [sectionDisable, setSectionDisable] = useState(false);
  const [isAllSectionScored, setIsAllSectionScored] = useState(false);
  const [updateHide, setUpdateHide] = useState(false);
  const [categoryToDisplay, setCategoryToDisplay] = useState([]);
  const [showCodingVideo, setShowCodingVideo] = useState(false);
  const [showTechnicalVideo, setShowTechnicalVideo] = useState(true);
  const [showBehavioralVideo, setShowBehavioralVideo] = useState(false);

  const matches = useMediaQuery("(min-width:900px)");
  const isAbove500 = useMediaQuery("(min-width: 500px)");

  // Download Report
  const onDownloadReport = () => {
    let payload = {
      inviteId: roleState?.invitedetails?.uid,
      type: "report",
      // reportName: "invite_report",
      accessCode: accessCode,
    };
    if (roleState?.invitedetails?.uid) {
      dispatch(role.downloadCR(payload));
    }
  };

  // const onDownloadFullReport = () => {     // FK cleanup july 2023
  //   let payload = {
  //     inviteId: roleState?.invitedetails?.uid,
  //     type: 'report',
  //     reportName:'invite_report',
  //     accessCode: accessCode
  //   }

  //   if (roleState?.invitedetails?.uid) {
  //     dispatch(role.downloadCR(payload))
  //   }
  // }

  useEffect(() => {
    if (roleState?.downloadcr?.status === 0) {
      window.open(roleState.downloadcr.data, "_self");
    }
    return () => dispatch(role.downloadReportStatus(null));
    // eslint-disable-next-line
  }, [roleState?.downloadcr?.status]);

  // Check if all sections are scored
  useEffect(() => {
    if (authState?.areaOfStrengthsAndImprovements?.sessionStatus) {
      let flag = true;
      for (let val of Object.values(authState?.areaOfStrengthsAndImprovements?.sessionStatus)) {
        if (val !== "") {
          if (val.status !== "scored") {
            flag = false;
          }
        }
      }
      setIsAllSectionScored(flag);
    }
  }, [authState?.areaOfStrengthsAndImprovements]);

  useEffect(() => {
    if (id) {
      dispatch(role.inviteDetails({ id: id, accessCode: accessCode }));
      setInviteLastUpdatedDate("");
      checkAndSetLastUpdatedDateOfInvite();
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (roleState.inviteDetailsFailure) {
      navigate("/inValidAccess");
    }
    // eslint-disable-next-line
  }, [roleState.inviteDetailsFailure]);

  const checkAndSetLastUpdatedDateOfInvite = () => {
    let inviteData = roleState.invitedetails;
    if (inviteData?.L3ProfileUpdatedDate) {
      if (inviteLastUpdatedDate === "") {
        setInviteLastUpdatedDate(inviteData.L3ProfileUpdatedDate);
      } else {
        if (moment(inviteData.L3ProfileUpdatedDate).isAfter(moment(inviteLastUpdatedDate))) {
          setInviteLastUpdatedDate(inviteData.L3ProfileUpdatedDate);
        }
      }
    }
    if (inviteData?.L2TechnicalScoreUpdatedDate) {
      if (inviteLastUpdatedDate === "") {
        setInviteLastUpdatedDate(inviteData.L2TechnicalScoreUpdatedDate);
      } else {
        if (moment(inviteData.L2TechnicalScoreUpdatedDate).isAfter(moment(inviteLastUpdatedDate))) {
          setInviteLastUpdatedDate(inviteData.L2TechnicalScoreUpdatedDate);
        }
      }
    }
    if (inviteData?.L3CodingUpdatedDate) {
      if (inviteLastUpdatedDate === "") {
        setInviteLastUpdatedDate(inviteData.L3CodingUpdatedDate);
      } else {
        if (moment(inviteData.L3CodingUpdatedDate).isAfter(moment(inviteLastUpdatedDate))) {
          setInviteLastUpdatedDate(inviteData.L3CodingUpdatedDate);
        }
      }
    }
    if (inviteData?.L3PresentationUpdatedDate) {
      if (inviteLastUpdatedDate === "") {
        setInviteLastUpdatedDate(inviteData.L3PresentationUpdatedDate);
      } else {
        if (moment(inviteData.L3PresentationUpdatedDate).isAfter(moment(inviteLastUpdatedDate))) {
          setInviteLastUpdatedDate(inviteData.L3PresentationUpdatedDate);
        }
      }
    }
  };

  useEffect(() => {
    checkAndSetLastUpdatedDateOfInvite();
    // eslint-disable-next-line
  }, [roleState.invitedetails]);

  const [fieldsData, setFieldsData] = useState({});
  useEffect(() => {
    if (roleState?.invitedetails) {
      setFieldsData(roleState?.invitedetails);
    }
  }, [roleState?.invitedetails]);

  const checkNullOrUndefined = (val) => {
    if (val !== undefined && val !== null) {
      return val;
    } else {
      return "";
    }
  };

  // function to get user name from URL
  const extractUsernameFromLink = (link) => {
    if (!link.includes("https://")) {
      link = `https://${link}`;
    }
    const url = new URL(link);
    const pathParts = url.pathname.split("/").filter((part) => part !== ""); // Filter out empty parts
    return pathParts[pathParts.length - 1];
  };

  useEffect(() => {
    if (roleState?.roleCategories && fieldsData?.jobRole?.category) {
      const categoryMapping = roleState?.roleCategories;
      if (categoryMapping && Array.isArray(fieldsData?.jobRole?.category)) {
        const categoryDisplayValue = fieldsData?.jobRole?.category?.map((category) => categoryMapping[category]);
        setCategoryToDisplay(categoryDisplayValue);
      }
      setSkeletonLoading(false);
    }
  }, [roleState?.roleCategories, fieldsData?.jobRole?.category]);

  const handleCodingVideo = () => {
    setShowCodingVideo(true);
    setShowTechnicalVideo(false);
    setShowBehavioralVideo(false);
  };

  const handleTechnicalVideo = () => {
    setShowCodingVideo(false);
    setShowTechnicalVideo(true);
    setShowBehavioralVideo(false);
  };

  const handleBehavioralVideo = () => {
    setShowCodingVideo(false);
    setShowTechnicalVideo(false);
    setShowBehavioralVideo(true);
  };

  // api call for chart data
  useEffect(() => {
    if (
      roleState?.invitedetails?.behavior?.type === "video" &&
      authState?.areaOfStrengthsAndImprovements?.sessionStatus?.presentation?.code &&
      accessCode
    ) {
      let payload = {
        sessionCode: authState?.areaOfStrengthsAndImprovements?.sessionStatus?.presentation?.code,
        token: accessCode,
      };
      dispatch(chart.radarChartData(payload));
    }
  }, [authState?.areaOfStrengthsAndImprovements, accessCode]);

  return (
    <Grid>
      {/* desktop view */}
      {matches ? (
        <div>
          <Grid
            style={{
              position: "fixed",
              top: "0",
              zIndex: "2",
              width: "100%",
              backgroundColor: "#FFFBF6",
              height: "100px",
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              alignItems: "center",
            }}
          >
            {fieldsData.logo ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start", paddingLeft: "20px" }}>
                <img src={fieldsData?.logo} alt="LOGO" style={{ height: "42px" }} />
                <img src={fieldsData?.subTitleLogo} alt="subLogo" style={{ height: "20px", marginTop: "10px" }} />
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start", paddingLeft: "20px" }}>
                <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                  <img src={fieldsData?.ytsLogo} alt="LOGO" style={{ height: "42px" }} />
                </a>
                <Typography>
                  <a
                    href="https://techscore.ai "
                    style={{ textDecoration: "none" }}
                    color="#787878"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span style={{ fontWeight: "400", color: "#787878" }}>techscore.ai</span>
                  </a>
                </Typography>
              </div>
            )}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "20px" }}>
              <Typography variant="h5" style={{ fontWeight: "600" }}>
                Candidate Evaluation Report {fieldsData.uid}
              </Typography>
            </div>
          </Grid>
          {!skeletonLoading ? (
            <>
              <Container maxWidth="xl" className={classes.container}>
                <Grid style={{ marginTop: "100px" }}>
                  {!isAuthLoading && !isInvitePageLoading ? (
                    <Grid>
                      <Grid container spacing={2}>
                        {/* Left Side */}
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2} xl={2} lg={2}>
                          <Grid container>
                            <Grid item xs={12} style={{ marginTop: "25px" }}>
                              <Typography variant="h6">{fieldsData?.candidate?.user?.displayName}</Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "35px" }}>
                              <img src={roleState?.invitedetails?.photoURL} alt="photoURL" style={{ width: "81%" }} />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                                Candidate Details
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography className={classes.roletype}>Candidate ID</Typography>
                              <Typography className={classes.leftSideContaint}>{fieldsData?.candidate?.uid}</Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                              <Typography className={classes.roletype}>Degree</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {fieldsData?.candidate?.degree}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                              <Typography className={classes.roletype}>Experience</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {fieldsData?.candidate?.yoe} Years
                              </Typography>
                            </Grid>
                            {fieldsData?.candidate?.location && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Location</Typography>
                                <Typography className={classes.leftSideContaint}>
                                  {fieldsData?.candidate?.location}
                                </Typography>
                              </Grid>
                            )}
                            {fieldsData?.candidate?.user?.email && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Email</Typography>
                                <Typography
                                  style={{
                                    color: "#2F2F2F",
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    marginTop: "8px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {fieldsData?.candidate?.user?.email}
                                </Typography>
                              </Grid>
                            )}
                            {fieldsData?.candidate?.user?.phone && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Phone</Typography>
                                <Typography className={classes.leftSideContaint}>
                                  {fieldsData?.candidate?.user?.phone}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          <Grid container>
                            <Grid item xs={12}>
                              {fieldsData?.LinkedIn_Profile && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>LinkedIn</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.LinkedIn_Profile}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.LinkedIn_Profile)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.GitHub && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>GitHub</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.GitHub}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.GitHub)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.Stack_Overflow && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>StackOverflow</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.Stack_Overflow}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.Stack_Overflow)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.CodeForces && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>CodeForces</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.CodeForces}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.CodeForces)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.HackerEarth && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>HackerEarth</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.HackerEarth}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.HackerEarth)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.HackerRank && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>HackerRank</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.HackerRank}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.HackerRank)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.LeetCode && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>LeetCode</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.LeetCode}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.LeetCode)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.SPOJ && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>SPOJ</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.SPOJ}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.SPOJ)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              {fieldsData?.TopCoder && (
                                <Grid item xs={12} style={{ marginTop: "10px" }}>
                                  <Typography className={classes.roletype}>TopCoder</Typography>
                                  <Typography className={classes.leftSideContaint}>
                                    <Link
                                      target="_blank"
                                      className={classes.linkStyles}
                                      to={fieldsData?.TopCoder}
                                      underline="none"
                                    >
                                      {extractUsernameFromLink(fieldsData?.TopCoder)} <OpenInNewIcon />
                                    </Link>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Right Side */}

                        <Grid item xs={8} xl={8} lg={8}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              style={{ marginTop: "25px", display: "flex", justifyContent: "space-between" }}
                            >
                              <Typography variant="h6">Role Details</Typography>
                              {fieldsData?.isCompleted === 1 && isAllSectionScored ? (
                                <Button
                                  onClick={onDownloadReport}
                                  variant="outlined"
                                  endIcon={<DownloadIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Download PDF
                                </Button>
                              ) : (
                                <Button
                                  disabled
                                  variant="outlined"
                                  endIcon={<DownloadIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Download PDF
                                </Button>
                              )}
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Role ID</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {roleState?.invitedetails?.jobRole?.uid}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Role Category</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {categoryToDisplay.length > 0 ? categoryToDisplay : []}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Role Name</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {roleState?.invitedetails?.jobRole?.name}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Required Degree</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {roleState?.invitedetails?.jobRole?.degree}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Required Experience</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {roleState?.invitedetails?.jobRole?.yoe} Years
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Coding Language</Typography>
                                <Tooltip
                                  title={
                                    roleState?.invitedetails?.codingLang
                                      ? roleState?.invitedetails?.codingLang.join(" / ")
                                      : "--"
                                  }
                                  placement="bottom-start"
                                >
                                  <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                    {codingLanguageDisplay(
                                      roleState?.invitedetails?.codingLang
                                        ? roleState?.invitedetails?.codingLang
                                        : ["--"]
                                    )}
                                  </Typography>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} sm={12} md={12} lg={9.5} marginTop="32px">
                            <Grid
                              style={{ marginTop: "77px", width: "120%" }}
                              container
                              direction="row"
                              justifyContent="center"
                              alignItems="center"
                              className={classes.graphScoreMeterContainer}
                            >
                              <Grid item xs={12} sm={12} md={8} lg={7} className={classes.graphScoreMeterCanvas}>
                                <GraphScoreMeter
                                  twoLineWithLink={true}
                                  line1={`Target role : ID ${checkNullOrUndefined(fieldsData?.jobRole?.uid)}`}
                                  line2={checkNullOrUndefined(fieldsData?.jobRole?.name)}
                                  line3={"Role category:"}
                                  line4={checkNullOrUndefined(categoryToDisplay.length > 0 ? categoryToDisplay : [])}
                                  targetScore={checkNullOrUndefined(fieldsData?.jobRole?.targetScore)}
                                  score={checkNullOrUndefined(fieldsData?.proportionalScore)}
                                  scoreMeterCls={classes.scoreMeter}
                                  className={`${classes.scoreMeter}`}
                                ></GraphScoreMeter>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={4}
                                lg={5}
                                className={classes.graphScoreMeterCanvas}
                                flexDirection="column"
                              >
                                <Typography className={classes.threeLine4}>Candidate Score</Typography>
                                <Typography
                                  className={classes.textdot}
                                  style={{
                                    color: fieldsData?.proportionalScore
                                      ? fieldsData?.proportionalScore >= fieldsData?.jobRole?.targetScore
                                        ? "#4087F4"
                                        : "#FF941C"
                                      : "#C4C4C4",
                                  }}
                                >
                                  {inviteLastUpdatedDate ? fieldsData?.proportionalScore : "---"}
                                </Typography>
                                {inviteLastUpdatedDate !== "" ? (
                                  <Typography className={classes.threeLine4}>
                                    As of {moment(fieldsData?.testCompletionOn).format("MMM DD, YYYY")}
                                  </Typography>
                                ) : (
                                  <Typography className={classes.threeLine4}>--</Typography>
                                )}
                                <hr style={{ borderBottom: "1px solid #EBEFF8", width: "75%" }} />
                                <Typography className={classes.threeLine4}>Target Score</Typography>
                                <Typography className={classes.textdot}>{fieldsData?.jobRole?.targetScore}</Typography>
                                <Typography className={classes.threeLine4}>
                                  Generated on {moment(fieldsData?.jobRole?.createdAt).format("MMM DD, YYYY")}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* Section dots display */}
                          <Grid item xs={12}>
                            <Grid container className={classes.grid_root}>
                              <Grid item xs={11.4}>
                                <QuizSection id={id} disabled={sectionDisable} updateHide={updateHide} />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} lg={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={9.6}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {fieldsData?.weSummary ? (
                                <>
                                  <Grid className={classes.textbreak}>
                                    <Typography className={classes.roletype}>Relevant Experience</Typography>
                                    <Typography sx={{ mt: 1, textAlign: "justify" }}>
                                      {fieldsData?.weSummary}
                                    </Typography>
                                    <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                                  </Grid>
                                </>
                              ) : (
                                ""
                              )}

                              {roleState?.invitedetails?.behavior?.type === "video" &&
                                chartState?.radarChartDataSuccess &&
                                Object.keys(chartState.radarChartDataSuccess).length > 0 && (
                                  <>
                                    <Typography className={classes.roletype}>Behavioral Analytics</Typography>
                                    <RadarChart />
                                  </>
                                )}
                              {fieldsData?.sessionTracking && (
                                <>
                                  <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />

                                  <Grid sx={{ display: "flex", justifyContent: "space-around" }}>
                                    <Button
                                      className={showTechnicalVideo ? classes.muiBtnActive : classes.muiBtn}
                                      onClick={handleTechnicalVideo}
                                    >
                                      Technical Section
                                    </Button>
                                    <Button
                                      className={showCodingVideo ? classes.muiBtnActive : classes.muiBtn}
                                      onClick={handleCodingVideo}
                                    >
                                      Coding Section
                                    </Button>
                                    <Button
                                      className={showBehavioralVideo ? classes.muiBtnActive : classes.muiBtn}
                                      onClick={handleBehavioralVideo}
                                    >
                                      Behavioral Section
                                    </Button>
                                  </Grid>
                                  {/* <Grid sx={{ mt: 2 }}>
                                    {showCodingVideo && (
                                      <Grid>
                                        <Grid container>
                                          <Grid item xs={5}>
                                            {fieldsData?.sessionTracking?.coding?.videoStream?.fileName ? (
                                              <VideoStream
                                                fileName={fieldsData?.sessionTracking?.coding?.videoStream?.fileName}
                                              />
                                            ) : Object.keys(fieldsData?.sessionTracking?.coding?.cameraCapture)
                                                .length === 0 ? (
                                              <Grid className={classes.notAvailable}>
                                                <Typography>No video available</Typography>
                                              </Grid>
                                            ) : (
                                              <>
                                                {" "}
                                                <ImageCarousel
                                                  images={Object.values(
                                                    fieldsData?.sessionTracking?.coding?.cameraCapture
                                                  ).map((imageData) => ({
                                                    url: imageData?.url,
                                                    createdAt: imageData?.createdAt,
                                                  }))}
                                                />{" "}
                                              </>
                                            )}
                                          </Grid>
                                          <Grid item xs={1}></Grid>
                                          <Grid item xs={6}>
                                            {fieldsData?.sessionTracking?.coding ? (
                                              <SessionTracking sessionData={fieldsData?.sessionTracking?.coding} />
                                            ) : (
                                              <Grid className={classes.notAvailable}>
                                                <Typography>No data available</Typography>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {showTechnicalVideo && (
                                      <Grid>
                                        <Grid container>
                                          <Grid item xs={5}>
                                            {fieldsData?.sessionTracking?.technical?.videoStream?.fileName ? (
                                              <VideoStream
                                                fileName={fieldsData?.sessionTracking?.technical?.videoStream?.fileName}
                                              />
                                            ) : Object.keys(fieldsData?.sessionTracking?.technical?.cameraCapture)
                                                .length === 0 ? (
                                              <Grid className={classes.notAvailable}>
                                                <Typography>No video available</Typography>
                                              </Grid>
                                            ) : (
                                              <>
                                                <ImageCarousel
                                                  images={Object.values(
                                                    fieldsData?.sessionTracking?.technical?.cameraCapture
                                                  ).map((imageData) => ({
                                                    url: imageData?.url,
                                                    createdAt: imageData?.createdAt,
                                                  }))}
                                                />{" "}
                                              </>
                                            )}
                                          </Grid>
                                          <Grid item xs={1}></Grid>
                                          <Grid item xs={6}>
                                            {fieldsData?.sessionTracking?.technical ? (
                                              <SessionTracking sessionData={fieldsData?.sessionTracking?.technical} />
                                            ) : (
                                              <Grid className={classes.notAvailable}>
                                                <Typography>No data available</Typography>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {showBehavioralVideo && (
                                      <Grid>
                                        <Grid container>
                                          <Grid item xs={5}>
                                            {fieldsData?.sessionTracking?.presentation?.videoStream?.fileName ? (
                                              <VideoStream
                                                fileName={
                                                  fieldsData?.sessionTracking?.presentation?.videoStream?.fileName
                                                }
                                              />
                                            ) : Object.keys(fieldsData?.sessionTracking?.presentation?.cameraCapture)
                                                .length === 0 ? (
                                              <Grid item xs={12} className={classes.notAvailable}>
                                                <Typography>No video available</Typography>
                                              </Grid>
                                            ) : (
                                              <>
                                                <ImageCarousel
                                                  images={Object.values(
                                                    fieldsData?.sessionTracking?.presentation?.cameraCapture
                                                  ).map((imageData) => ({
                                                    url: imageData?.url,
                                                    createdAt: imageData?.createdAt,
                                                  }))}
                                                />
                                              </>
                                            )}
                                          </Grid>
                                          <Grid item xs={1}></Grid>
                                          <Grid item xs={6}>
                                            {fieldsData?.sessionTracking?.presentation ? (
                                              <SessionTracking
                                                sessionData={fieldsData?.sessionTracking?.presentation}
                                              />
                                            ) : (
                                              <Grid item xs={12} className={classes.notAvailable}>
                                                <Typography>No data available</Typography>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid> */}
                                  <Grid sx={{ mt: 2 }}>
                                    {showCodingVideo && (
                                      <VideoAndSessionTracking
                                        videoStream={fieldsData?.sessionTracking?.coding?.videoStream}
                                        cameraCapture={fieldsData?.sessionTracking?.coding?.cameraCapture}
                                        sessionData={fieldsData?.sessionTracking?.coding}
                                        type="coding"
                                      />
                                    )}
                                    {showTechnicalVideo && (
                                      <VideoAndSessionTracking
                                        videoStream={fieldsData?.sessionTracking?.technical?.videoStream}
                                        cameraCapture={fieldsData?.sessionTracking?.technical?.cameraCapture}
                                        sessionData={fieldsData?.sessionTracking?.technical}
                                        type="technical"
                                      />
                                    )}
                                    {showBehavioralVideo && (
                                      <VideoAndSessionTracking
                                        videoStream={fieldsData?.sessionTracking?.presentation?.videoStream}
                                        cameraCapture={fieldsData?.sessionTracking?.presentation?.cameraCapture}
                                        sessionData={fieldsData?.sessionTracking?.presentation}
                                        type="presentation"
                                      />
                                    )}
                                  </Grid>
                                </>
                              )}
                            </Grid>
                            <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Container>
              <Footer />

              <SimpleSnackbar open={open} setOpen={setOpen} text={snacktext} />
            </>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={1} mt={"80px"} width={"80%"}>
                <Grid item xs={12} md={12}>
                  <Grid container item xs={12} md={12} columnSpacing={4} mt={4}>
                    <Grid container item xs={3} md={3} height={"700px"}>
                      <Grid item xs={12} md={12}>
                        <Box mb={2}>
                          <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                        </Box>
                      </Grid>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="170px" height="180px" />
                      <Skeleton variant="text" sx={{ fontSize: "12px", width: "100%", marginBottom: "20px" }} />

                      {Array.from({ length: 4 }).map((_, index) => (
                        <Stack width={"100%"} height={"60px"} spacing={0.8}>
                          <Skeleton key={index} variant="text" sx={{ fontSize: "22px", width: "80%" }} />
                          <Skeleton key={index} variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        </Stack>
                      ))}
                    </Grid>

                    <Grid container item xs={9} md={9}>
                      <Grid item xs={12} md={12}>
                        <Box mb={2} sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />
                        </Box>
                      </Grid>

                      <Grid container item xs={12} md={12} spacing={2} mt={1.5}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} marginTop={2}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                              </Stack>
                            </Grid>
                            <Grid item xs={8} md={8}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container item xs={12} md={12} columnSpacing={4}>
                        <Grid item xs={12} md={12} mt={3}>
                          <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="280px" />
                        </Grid>
                        <Grid item xs={12} md={12} mt={2}>
                          <Skeleton variant="text" sx={{ fontSize: "25px", width: "45%" }} />
                        </Grid>

                        <Grid container item xs={12} spacing={2} md={12} mt={1}>
                          <Grid item xs={6} md={6}>
                            <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={12} md={12} mt={2}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "10%" }} />

                      <Grid item xs={12} md={12} mt={1.5}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "40%" }} />
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                  <Grid container item xs={12} md={12} columnSpacing={4} mb={5}>
                    <Grid item xs={4} md={4}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                    </Grid>
                    <Grid item xs={4} md={4}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                    </Grid>
                    <Grid item xs={4} md={4}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                    </Grid>
                    <Grid container item xs={12} md={12} columnSpacing={1}>
                      <Grid item xs={6} md={6} mt={3}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="250px" />
                      </Grid>
                      <Grid item xs={6} md={6} mt={3}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="250px" />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={12} mt={2}>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="100px" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
      ) : (
        <div>
          {/* mobile and tablet view */}
          <Grid
            style={{
              position: "fixed",
              top: "0",
              zIndex: "2",
              width: "100%",
              backgroundColor: "#FFFBF6",
              height: "100px",
            }}
          >
            {fieldsData.logo ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "2px" }}>
                <img src={fieldsData?.logo} alt="LOGO" style={{ height: "35px" }} />
                <img src={fieldsData?.subTitleLogo} alt="subLogo" style={{ height: "17px", marginTop: "10px" }} />
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "2px" }}>
                <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                  <img src={fieldsData?.ytsLogo} alt="LOGO" style={{ height: "35px" }} />
                </a>
                <Typography>
                  <a
                    href="https://techscore.ai "
                    style={{ textDecoration: "none" }}
                    color="#787878"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span style={{ fontWeight: "400", color: "#787878" }}>techscore.ai</span>
                  </a>
                </Typography>
              </div>
            )}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Typography variant="h6" style={{ fontWeight: "600", padding: "1px" }}>
                Candidate Evaluation Report {fieldsData.uid}
              </Typography>
            </div>
          </Grid>
          {!skeletonLoading ? (
            <>
              <Container maxWidth="xl" className={classes.container}>
                <Grid style={{ marginTop: "100px" }}>
                  {!isAuthLoading && !isInvitePageLoading ? (
                    <Grid container spacing={2}>
                      {/* Left Side */}
                      <Grid
                        lg={4}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "40px",
                        }}
                      >
                        {fieldsData?.isCompleted === 1 && isAllSectionScored ? (
                          <Button
                            onClick={onDownloadReport}
                            variant="outlined"
                            endIcon={<DownloadIcon />}
                            sx={{ textTransform: "none" }}
                          >
                            Download PDF
                          </Button>
                        ) : (
                          <Button disabled variant="outlined" endIcon={<DownloadIcon />} sx={{ textTransform: "none" }}>
                            Download PDF
                          </Button>
                        )}
                        <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "7px" }}>
                          <Typography variant="h6">{fieldsData?.candidate?.user?.displayName}</Typography>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          style={{ marginTop: "35px", display: "flex", justifyContent: "center" }}
                        >
                          <img src={roleState?.invitedetails?.photoURL} alt="photoURL" style={{ width: "50%" }} />
                        </Grid>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12}>
                        <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                          Candidate Details
                        </Typography>
                      </Grid>
                      <Grid container lg={8} md={12} sm={12} xs={12} style={{ paddingLeft: "15px" }}>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Candidate ID</Typography>
                          <Typography className={classes.leftSideContaint}>{fieldsData?.candidate?.uid}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Degree</Typography>
                          <Typography className={classes.leftSideContaint}>{fieldsData?.candidate?.degree}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Experience</Typography>
                          <Typography className={classes.leftSideContaint}>
                            {fieldsData?.candidate?.yoe} Years
                          </Typography>
                        </Grid>
                        {fieldsData?.candidate?.location && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Location</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {fieldsData?.candidate?.location}
                            </Typography>
                          </Grid>
                        )}
                        {fieldsData?.candidate?.user?.email && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Email</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {fieldsData?.candidate?.user?.email}
                            </Typography>
                          </Grid>
                        )}
                        {fieldsData?.candidate?.user?.phone && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Phone</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {fieldsData?.candidate?.user?.phone}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>

                      {fieldsData?.LinkedIn_Profile && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>LinkedIn</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.LinkedIn_Profile}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.LinkedIn_Profile)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.GitHub && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>GitHub</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.GitHub}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.GitHub)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.Stack_Overflow && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>StackOverflow</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.Stack_Overflow}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.Stack_Overflow)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.CodeForces && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>CodeForces</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.CodeForces}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.CodeForces)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.HackerEarth && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>HackerEarth</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.HackerEarth}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.HackerEarth)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.HackerRank && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>HackerRank</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.HackerRank}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.HackerRank)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.LeetCode && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>LeetCode</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.LeetCode}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.LeetCode)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.SPOJ && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>SPOJ</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link target="_blank" className={classes.linkStyles} to={fieldsData?.SPOJ} underline="none">
                              {extractUsernameFromLink(fieldsData?.SPOJ)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}

                      {fieldsData?.TopCoder && (
                        <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginTop: "10px" }}>
                          <Typography className={classes.roletype}>TopCoder</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Link
                              target="_blank"
                              className={classes.linkStyles}
                              to={fieldsData?.TopCoder}
                              underline="none"
                            >
                              {extractUsernameFromLink(fieldsData?.TopCoder)} <OpenInNewIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      )}
                      {/* Right Side */}

                      <Grid item xs={12} xl={8} lg={8}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} style={{ marginTop: "10px" }}>
                            <Typography variant="h6">Role Details</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid container direction="column">
                              <Typography className={classes.roletype}>Role ID</Typography>
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {roleState?.invitedetails?.jobRole?.uid}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid container direction="column">
                              <Typography className={classes.roletype}>Role Category</Typography>
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {categoryToDisplay.length > 0 ? categoryToDisplay : []}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid container direction="column">
                              <Typography className={classes.roletype}>Role Name</Typography>
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {roleState?.invitedetails?.jobRole?.name}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid container direction="column">
                              <Typography className={classes.roletype}>Required Degree</Typography>
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {roleState?.invitedetails?.jobRole?.degree}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid container direction="column">
                              <Typography className={classes.roletype}>Required Experience</Typography>
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {roleState?.invitedetails?.jobRole?.yoe} Years
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Grid container direction="column">
                              <Typography className={classes.roletype}>Coding Language</Typography>
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {codingLanguageDisplay(
                                  roleState?.invitedetails?.codingLang ? roleState?.invitedetails?.codingLang : ["--"]
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={9.5} marginTop="32px">
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            className={classes.mobileGraphScoreMeterContainer}
                          >
                            <Grid item xs={12} sm={12} md={8} lg={7} className={classes.mobileGraphScoreMeterCanvas}>
                              {isAbove500 ? (
                                // above 600 pixels
                                <GraphScoreMeter
                                  twoLineWithLink={true}
                                  line1={`Target role : ID ${checkNullOrUndefined(fieldsData?.jobRole?.uid)}`}
                                  line2={checkNullOrUndefined(fieldsData?.jobRole?.name)}
                                  line3={"Role category:"}
                                  line4={checkNullOrUndefined(categoryToDisplay.length > 0 ? categoryToDisplay : [])}
                                  targetScore={checkNullOrUndefined(fieldsData?.jobRole?.targetScore)}
                                  score={checkNullOrUndefined(fieldsData?.proportionalScore)}
                                  scoreMeterCls={classes.scoreMeter}
                                  className={`${classes.scoreMeter}`}
                                />
                              ) : (
                                // below 600px
                                <GraphScoreMeter
                                  twoLineWithLink={true}
                                  line1={
                                    <Typography style={{ fontSize: "8px" }}>
                                      Target role : ID {checkNullOrUndefined(fieldsData?.jobRole?.uid)}
                                    </Typography>
                                  }
                                  line2={
                                    <Typography style={{ fontSize: "12px" }}>
                                      <b>
                                        {" "}
                                        {checkNullOrUndefined(
                                          fieldsData?.jobRole?.name.length <= 24
                                            ? fieldsData?.jobRole?.name
                                            : fieldsData?.jobRole?.name.substr(0, 24) + "..."
                                        )}
                                      </b>
                                    </Typography>
                                  }
                                  line3={<Typography style={{ fontSize: "8px" }}>Role category:</Typography>}
                                  line4={
                                    <Typography style={{ fontSize: "8px", marginBottom: "50px" }}>
                                      {checkNullOrUndefined(categoryToDisplay.length > 0 ? categoryToDisplay : [])}
                                    </Typography>
                                  }
                                  targetScore={checkNullOrUndefined(fieldsData?.jobRole?.targetScore)}
                                  score={checkNullOrUndefined(fieldsData?.proportionalScore)}
                                />
                              )}
                            </Grid>
                            <Grid
                              item
                              xs={11}
                              sm={11}
                              md={4}
                              lg={5}
                              className={classes.mobileGraphScoreMeterCanvas}
                              flexDirection="column"
                            >
                              <Typography className={classes.threeLine4}>Candidate Score</Typography>
                              <Typography
                                className={classes.textdot}
                                style={{
                                  color: fieldsData?.proportionalScore
                                    ? fieldsData?.proportionalScore >= fieldsData?.jobRole?.targetScore
                                      ? "#4087F4"
                                      : "#FF941C"
                                    : "#C4C4C4",
                                }}
                              >
                                {inviteLastUpdatedDate ? fieldsData?.proportionalScore : "---"}
                              </Typography>
                              {inviteLastUpdatedDate !== "" ? (
                                <Typography className={classes.threeLine4}>
                                  As of {moment(fieldsData?.testCompletionOn).format("MMM DD, YYYY")}
                                </Typography>
                              ) : (
                                <Typography className={classes.threeLine4}>--</Typography>
                              )}
                              <hr style={{ borderBottom: "1px solid #EBEFF8", width: "75%" }} />
                              <Typography className={classes.threeLine4}>Target Score</Typography>
                              <Typography className={classes.textdot}>{fieldsData?.jobRole?.targetScore}</Typography>
                              <Typography className={classes.threeLine4}>
                                Generated on {moment(fieldsData?.jobRole?.createdAt).format("MMM DD, YYYY")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Section dots display */}
                        <Grid item xs={12}>
                          <Grid container className={classes.grid_root}>
                            <Grid item xs={11.4}>
                              <QuizSection id={id} disabled={sectionDisable} updateHide={updateHide} />
                            </Grid>
                          </Grid>
                        </Grid>
                        {fieldsData?.weSummary ? (
                          <>
                            <p style={{ borderBottom: "1px solid #C4C4C4" }} />
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid style={{ marginTop: "10px" }} className={classes.textbreak}>
                                    <Typography className={classes.roletype}>Relevant Experience</Typography>
                                    {
                                      <Typography sx={{ mt: 1, textAlign: "justify" }}>
                                        {fieldsData?.weSummary}
                                      </Typography>
                                    }
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ""
                        )}
                        {roleState?.invitedetails?.behavior?.type === "video" &&
                          chartState?.radarChartDataSuccess &&
                          Object.keys(chartState.radarChartDataSuccess).length > 0 && (
                            <>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              <Typography className={classes.roletype}>Behavioral Analytics</Typography>
                              <RadarChart />
                            </>
                          )}
                        <p style={{ borderBottom: "1px solid #C4C4C4", marginLeft: "0px", width: "100%" }} />
                        {fieldsData?.sessionTracking && (
                          <>
                            <Grid sx={{ display: "flex", justifyContent: "space-around" }}>
                              <Button
                                className={showTechnicalVideo ? classes.muiBtnActive : classes.muiBtn}
                                onClick={handleTechnicalVideo}
                              >
                                Technical Section
                              </Button>
                              <Button
                                className={showCodingVideo ? classes.muiBtnActive : classes.muiBtn}
                                onClick={handleCodingVideo}
                              >
                                Coding Section
                              </Button>
                              <Button
                                className={showBehavioralVideo ? classes.muiBtnActive : classes.muiBtn}
                                onClick={handleBehavioralVideo}
                              >
                                Behavioral Section
                              </Button>
                            </Grid>
                            {/* <Grid container>
                              {showCodingVideo && (
                                <>
                                  <Grid item xs={12}>
                                    {fieldsData?.sessionTracking?.coding?.videoStream?.fileName ? (
                                      <VideoStream
                                        fileName={fieldsData?.sessionTracking?.coding?.videoStream?.fileName}
                                      />
                                    ) : Object.keys(fieldsData?.sessionTracking?.coding?.cameraCapture).length === 0 ? (
                                      <Grid className={classes.notAvailable}>
                                        <Typography>No video available</Typography>
                                      </Grid>
                                    ) : (
                                      <>
                                        {" "}
                                        <ImageCarousel
                                          images={Object.values(fieldsData?.sessionTracking?.coding?.cameraCapture).map(
                                            (imageData) => ({
                                              url: imageData?.url,
                                              createdAt: imageData?.createdAt,
                                            })
                                          )}
                                        />{" "}
                                      </>
                                    )}
                                  </Grid>
                                  <Grid item sx={12}>
                                    {fieldsData?.sessionTracking?.coding ? (
                                      <SessionTracking sessionData={fieldsData?.sessionTracking?.coding} />
                                    ) : (
                                      <Grid className={classes.notAvailable}>
                                        <Typography>No data available</Typography>
                                      </Grid>
                                    )}
                                  </Grid>
                                </>
                              )}
                              {showTechnicalVideo && (
                                <>
                                  <Grid item xs={12}>
                                    {fieldsData?.sessionTracking?.technical?.videoStream?.fileName ? (
                                      <VideoStream
                                        fileName={fieldsData?.sessionTracking?.technical?.videoStream?.fileName}
                                      />
                                    ) : Object.keys(fieldsData?.sessionTracking?.technical?.cameraCapture).length ===
                                      0 ? (
                                      <Grid className={classes.notAvailable}>
                                        <Typography>No video available</Typography>
                                      </Grid>
                                    ) : (
                                      <>
                                        <ImageCarousel
                                          images={Object.values(
                                            fieldsData?.sessionTracking?.technical?.cameraCapture
                                          ).map((imageData) => ({
                                            url: imageData?.url,
                                            createdAt: imageData?.createdAt,
                                          }))}
                                        />
                                      </>
                                    )}
                                  </Grid>
                                  <Grid item xs={12}>
                                    {fieldsData?.sessionTracking?.technical ? (
                                      <SessionTracking sessionData={fieldsData?.sessionTracking?.technical} />
                                    ) : (
                                      <Grid className={classes.notAvailable}>
                                        <Typography>No data available</Typography>
                                      </Grid>
                                    )}
                                  </Grid>
                                </>
                              )}
                              {showBehavioralVideo && (
                                <>
                                  <Grid item xs={12}>
                                    {fieldsData?.sessionTracking?.presentation?.videoStream?.fileName ? (
                                      <VideoStream
                                        fileName={fieldsData?.sessionTracking?.presentation?.videoStream?.fileName}
                                      />
                                    ) : Object.keys(fieldsData?.sessionTracking?.presentation?.cameraCapture).length ===
                                      0 ? (
                                      <Grid className={classes.notAvailable}>
                                        <Typography>No video available</Typography>
                                      </Grid>
                                    ) : (
                                      <>
                                        <ImageCarousel
                                          images={Object.values(
                                            fieldsData?.sessionTracking?.presentation?.cameraCapture
                                          ).map((imageData) => ({
                                            url: imageData?.url,
                                            createdAt: imageData?.createdAt,
                                          }))}
                                        />
                                      </>
                                    )}
                                  </Grid>
                                  <Grid item xs={12}>
                                    {fieldsData?.sessionTracking?.presentation ? (
                                      <SessionTracking sessionData={fieldsData?.sessionTracking?.presentation} />
                                    ) : (
                                      <Grid className={classes.notAvailable}>
                                        <Typography>No data available</Typography>
                                      </Grid>
                                    )}
                                  </Grid>
                                </>
                              )}
                            </Grid> */}
                            <Grid>
                              {showCodingVideo && (
                                <VideoAndSessionTracking
                                  videoStream={fieldsData?.sessionTracking?.coding?.videoStream}
                                  cameraCapture={fieldsData?.sessionTracking?.coding?.cameraCapture}
                                  sessionData={fieldsData?.sessionTracking?.coding}
                                  type="coding"
                                />
                              )}
                              {showTechnicalVideo && (
                                <VideoAndSessionTracking
                                  videoStream={fieldsData?.sessionTracking?.technical?.videoStream}
                                  cameraCapture={fieldsData?.sessionTracking?.technical?.cameraCapture}
                                  sessionData={fieldsData?.sessionTracking?.technical}
                                  type="technical"
                                />
                              )}
                              {showBehavioralVideo && (
                                <VideoAndSessionTracking
                                  videoStream={fieldsData?.sessionTracking?.presentation?.videoStream}
                                  cameraCapture={fieldsData?.sessionTracking?.presentation?.cameraCapture}
                                  sessionData={fieldsData?.sessionTracking?.presentation}
                                  type="presentation"
                                />
                              )}
                            </Grid>
                            <p style={{ borderBottom: "1px solid #C4C4C4", marginLeft: "0px", width: "100%" }} />
                          </>
                        )}
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Container>
              <Footer />

              <SimpleSnackbar open={open} setOpen={setOpen} text={snacktext} />
            </>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={1} mt={"80px"} width={"80%"}>
                <Grid item xs={12} md={12}>
                  <Grid item xs={12} md={12} mt={5}>
                    <Box
                      sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                    >
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                    </Box>
                  </Grid>
                  {/* <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                  <Grid container item xs={12} md={12} columnSpacing={4} mt={4}>
                    <Grid container item xs={12} md={12} justifyContent="center">
                      <stack>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="170px" height="180px" />
                      </stack>

                      <Grid container item xs={12} md={12} spacing={2} mt={2}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "25px", width: "70%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} marginTop={2}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container item xs={12} md={12} spacing={2} mt={3}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "25px", width: "70%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={12} md={12} mt={3}>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="280px" />
                    </Grid>
                    <Grid item xs={12} md={12} mt={2}>
                      <Skeleton variant="text" sx={{ fontSize: "25px", width: "45%" }} />
                    </Grid>

                    <Grid container item xs={12} spacing={2} md={12} mt={1}>
                      <Grid item xs={6} md={6}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={12} md={12} mt={2}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "10%" }} />

                      <Grid item xs={12} md={12} mt={1.5}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "40%" }} />
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                  <Grid container item xs={12} md={12} columnSpacing={4} mb={5}>
                    <Grid item xs={4} md={4}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                    </Grid>
                    <Grid item xs={4} md={4}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                    </Grid>
                    <Grid item xs={4} md={4}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                    </Grid>
                    <Grid container item xs={12} md={12} columnSpacing={1}>
                      <Grid item xs={6} md={6} mt={3}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="250px" />
                      </Grid>
                      <Grid item xs={6} md={6} mt={3}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="250px" />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={12} mt={2}>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="100px" />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
      )}
    </Grid>
  );
}
